<template>
    <a-card :bordered="false" :loading="pageLoading" v-if="pageLoading">Loading ...</a-card>
    <a-row :gutter="8" v-else>
      <loading v-if="anggaran.loadingtree" />
      <a-col :xs="{ span: 24 }">
        <a-form :form="form">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item label="Ticket Type">
                <a-radio-group
                  v-decorator="[
                    'tipe_tiket',
                    {
                      rules: [{ required: true }],
                      initialValue: 'Bus',
                    },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="Bus">Bus</a-radio-button>
                  <a-radio-button value="Car">Car</a-radio-button>
                  <a-radio-button value="Flight">Flight</a-radio-button>
                  <a-radio-button value="Hotel">Hotel</a-radio-button>
                </a-radio-group>
              </a-form-item>

              <a-form-item label="User Booking">
                <a-select
                  showSearch
                  v-decorator="['user_booking',
                        {
                            rules: [{ required: true }],
                            initialValue: informasi.end_user
                        },
                    ]"
                  :filterOption="filterOption"
                >
                  <a-select-option v-for="item in getAllKaryawan" :key="item.tlc">
                    {{item.tlc}} - {{item.nama}}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="No. Booking">
                <a-input v-decorator="['no_booking', { rules: [{ required: true }] }]"></a-input>
              </a-form-item>

              <a-form-item label="Description">
                <a-input v-decorator="['deskripsi', { rules: [{ required: true }] }]"></a-input>
              </a-form-item>
  
              <a-row :gutter="16">
                <a-col :span="11">
                  <a-form-item label="Budget Type">
                    <a-radio-group
                      v-decorator="[
                        'category',
                        {
                          rules: [{ required: false }],
                          initialValue: 'SPPD',
                        },
                      ]"
                      ref="refcategory"
                      button-style="solid"
                    >
                      <a-radio-button value="SPPD">SPPD</a-radio-button>
                      <a-radio-button value="PP">PP</a-radio-button>
                      <a-radio-button value="COST_CENTER">COST CENTER</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="13">
                  <a-form-item label="SPPD No" v-if="!$refs.refcategory || ($refs && $refs.refcategory && $refs.refcategory.value=='SPPD')">
                    <a-select
                      showSearch
                      allowClear
                      :not-found-content="null"
                      option-filter-prop="children"
                      v-decorator="['sppd_no', { rules: [{ required: false }], initialValue: informasi.sppd_no}]"
                      :default-active-first-option="false"
                      :filter-option="false"
                      placeholder="Type to Search"
                      @search="handleSearchSPPD"
                      @change="onChangeSppdNo"
                    >
                      <a-select-option v-for="item in dataSPPDList" :key="item.id_sppd">
                        {{item.no_sppd}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="PP No" v-if="$refs && $refs.refcategory && $refs.refcategory.value=='PP'">
                    <a-select
                      showSearch
                      allowClear
                      :not-found-content="null"
                      option-filter-prop="children"
                      :default-active-first-option="false"
                      :filter-option="false"
                      v-decorator="['pp_no', { rules: [{ required: false }], initialValue: informasi.id_pp}]"
                      placeholder="Type to Search"
                      @search="handleSearchPP"
                      @change="onChangePPNo"
                    >
                      <a-select-option v-for="item in dataPPList" :key="item.id_pp">
                        {{item.no_pp}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Cost Center" v-if="$refs && $refs.refcategory && $refs.refcategory.value=='COST_CENTER'">
                    <a-select
                      showSearch
                      allowClear
                      :not-found-content="null"
                      option-filter-prop="children"
                      :default-active-first-option="false"
                      :filter-option="false"
                      v-decorator="['cost_center', { rules: [{ required: false }], initialValue: informasi.cost_center}]"
                      placeholder="Type to Search"
                      @search="handleSearchCostCenter"
                      @change="onChangeCostCenter"
                    >
                      <a-select-option v-for="item in dataPPList" :key="item.id">
                        {{item.label}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
  
              <a-row :gutter="16">
                <a-col :span="9">
                  <a-form-item label="End User Type">
                    <a-radio-group
                      v-decorator="[
                        'type_user',
                        {
                          rules: [{ required: true }],
                          initialValue: 'employee',
                        },
                      ]"
                      ref="reftype_user"
                      button-style="solid"
                      :filterOption="filterOption"
                    >
                      <a-radio-button value="employee">Employee</a-radio-button>
                      <a-radio-button value="foreigner">Foreigner</a-radio-button>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="15">
                  <a-form-item label="Employee" v-if="!$refs.reftype_user || ($refs && $refs.reftype_user && $refs.reftype_user.value=='employee')">
                    <a-select
                      showSearch
                      v-decorator="['end_user',
                            {
                                rules: [{ required: true }],
                                initialValue: informasi.end_user
                            },
                        ]"
                    >
                      <a-select-option v-for="item in getCCEmpList" :key="item.tlc">
                        {{item.tlc}} - {{item.nama}}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item label="Foreigner Name" v-if="$refs && $refs.reftype_user && $refs.reftype_user.value=='foreigner'">
                    <a-input v-decorator="['end_user_name', { rules: [{ required: true }] }]"></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
  
              <a-form-item label="Credit">
                <a-input-number
                  :min="0"
                  @keydown="onlyNumber"
                  class="m-width-full"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  v-decorator="[
                    'kredit',
                    { rules: [{ required: true }, { validator: checkPrice }] },
                  ]"
                />
              </a-form-item>
              <a-form-item label="Expense Date">
                <a-date-picker
                  placeholder="Select Date"
                  :format="getDefaultDateFormat"
                  v-decorator="[
                    'tanggal_pengeluaran',
                    { rules: [{ required: true }] },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item label="Upload Transaction Document">
            <a-upload
              :showUploadList="true"
              :fileList="doctransfiles"
              :beforeUpload="beforedoctransUpload"
              :remove="handledoctransRemove"
              v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
            >
              <a-button>
                <a-icon type="upload" />&nbsp;Select File
              </a-button>
            </a-upload>
          </a-form-item>
        </a-form>

        <a-divider class="margin-bottom-small">or</a-divider>
          <div>
            <h4>Upload File Excel</h4>
            <p>
              If you don't have the file upload template yet, please kindly click
              <a-button class="padding-remove" type="link" @click="handleDownloadTemplate"
                >Download Template</a-button
              >
            </p>
            <a-upload
              accept=".xls, .xlsx"
              :showUploadList="true"
              :fileList="push"
              :beforeUpload="beforeUploadTemplate"
              :remove="handleRemoveTemplate"
              v-decorator="['upload', { valuePropName: 'push' }]"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select your file </a-button>
            </a-upload>
            <a-divider v-if="getScreen"></a-divider>
          </div>

        <a-button v-if="getScreen" type="primary" block @click="handleNew" :loading="newLoading">Add</a-button>
      </a-col>
      <a-col :xs="{ span: 24 }" v-if="getScreen">
        <a-collapse class="margin-top">
          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">View Details</h4>
            <a-list itemLayout="vertical" :dataSource="dataList" :pagination="pagination">
              <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <a-row slot="title" type="flex" justify="space-between">
                    <a href="#">{{ item.deskripsi }}</a>
                  </a-row>
                  <ul slot="description" class="m-list-wrapper">
                    <li class="margin-remove">
                      {{
                      moment(item.tanggal_pemakaian).format(
                      getDefaultDateFormat
                      )
                      }}
                    </li>
                    <li class="margin-remove">{{ item.alokasi }} | {{ item.proyek }}</li>
  
                    <li>
                      <h3 class="margin-remove">{{ formatRupiah(item.kredit) }}</h3>
                    </li>
                  </ul>
                </a-list-item-meta>
                <a-button-group v-if="getScreen && item.kredit !== ''">
                  <a-button type="primary" @click="handleEdit(item)">
                    <a-icon type="edit" />&nbsp;Edit
                  </a-button>
                  <a-button type="danger" @click="handleRemoveDetail(item)">
                    <a-icon type="close" />&nbsp;Remove
                  </a-button>
                </a-button-group>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
        <div class="m-price-total">
          <!--  <h3 class="margin-remove m-text-align right" >Total : {{formatCurrency(mata_uang,totalPrice)}}</h3>
            <h3 class="margin-remove m-text-align right" >Tax ({{tax+'%'}}) : {{formatCurrency(mata_uang,nilaiPajak)}}</h3>
          <h3 class="margin-remove m-text-align right" v-if="check_shipping">Shipping Cost  : {{formatCurrency(mata_uang,shipping)}}</h3>-->
          <a-statistic
            title="Grand Total"
            :value="formatRupiah(this.kredit)"
            class="m-text-align right"
          />
        </div>
        <a-checkbox :disabled="dataList.length < 1" @change="handleCheckData">Is Data Completed?</a-checkbox>
      </a-col>

      <a-modal
        v-model="modalanggaran.visible"
        v-if="modalanggaran.visible"
        title="Choice Financing Code"
        :footer="null"
        :width="700"
      >
        <a-tree-select
          v-model="modalanggaran.value"
          show-search
          style="width: 100%"
          @change="handlechoiceCost"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="modalanggaran.tree"
          treeNodeFilterProp="children"
          :filterTreeNode="filterTreeNode"
          placeholder="Please select"
          allow-clear
          tree-default-expand-all
        >
          <span slot="title" slot-scope="item">
            <table style="width:100%">
              <tr>
                <td>
                  <span>{{item.texttitle}} - {{item.kode_anggaran}}</span>
                </td>
                <td>
                  <span style="float:right">{{formatRupiah(parseFloat(item.rekap))}}</span>
                </td>
              </tr>
            </table>
          </span>
        </a-tree-select>
      </a-modal>
      <a-modal
          title="Confirmation"
          :visible="confirm"
          @ok="handleconfirmOk"
          :confirmLoading="confirmLoading"
          @cancel="handleconfirmCancel"
          okText= "OK"
          cancelText= "Cancel"
          :maskClosable="false"
        >
          <p>The data that has been added will be overwritten with your new file? Are you sure?</p>
        </a-modal>
    </a-row>
  </template>
  
  <script>
  import axios from "axios";
  import moment from "moment";
  import { mapGetters } from "vuex";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  // import Modal from "../Modal.vue";
  import Loading from "@/components/preloader/Loading.vue";
  import GlobalMethod from "@/mixins/GlobalMethod.js";

  let SPPDCombotimeout;
  let SPPDcurrentValue;

  function fetchLazySPPD(source, value, callback) {
    if (SPPDCombotimeout) {
      clearTimeout(SPPDCombotimeout);
      SPPDCombotimeout = null;
    }
    SPPDcurrentValue = value;

    function lazySPPD() {
      const data = []
      if(SPPDcurrentValue){
        const result = source.filter(item=> item.no_sppd.toLowerCase().includes(SPPDcurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id_sppd: r.id_sppd,
            no_sppd: r.no_sppd,
          });
        });
      }
        callback(data);
      }

    SPPDCombotimeout = setTimeout(lazySPPD, 300);
  }

  let PPCombotimeout;
  let PPcurrentValue;

  function fetchLazyPP(source, value, callback) {
    if (PPCombotimeout) {
      clearTimeout(PPCombotimeout);
      PPCombotimeout = null;
    }
    PPcurrentValue = value;

    function lazyPP() {
      const data = []
      if(PPcurrentValue){
        const result = source.filter(item=> item.no_pp.toLowerCase().includes(PPcurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id_pp: r.id_pp,
            no_pp: r.no_pp,
          });
        });
      }
        callback(data);
      }

    PPCombotimeout = setTimeout(lazyPP, 300);
  }

  let CostCenterCombotimeout;
  let CostCentercurrentValue;

  function fetchLazyCostCenter(source, value, callback) {
    if (CostCenterCombotimeout) {
      clearTimeout(CostCenterCombotimeout);
      CostCenterCombotimeout = null;
    }
    CostCentercurrentValue = value;

    function lazyCostCenter() {
      const data = []
      if(CostCentercurrentValue){
        const result = source.filter(item=> item.text.toLowerCase().includes(CostCentercurrentValue.toLowerCase()))
        result.forEach(r => {
          data.push({
            id: r.text,
            label: r.text,
          });
        });
      }
        callback(data);
      }

    CostCenterCombotimeout = setTimeout(lazyCostCenter, 300);
  }
  
  export default {
    name: "PemakaianClaimTiket",
    components: {
      // Modal,
      Loading,
    },
    mixins: [CurrencyFormat,GlobalMethod],
    props: {
      data: {},
      informasi: {},
      mode: {},
      url: "",
      id_laporan: "",
      dataList: {},
      debit: 0,
      kredit: 0,
      mata_uang: "",
      type: "",
    },
    data() {
      return {
        push: [],
        confirm: false,
        confirmLoading: false,
        newLoading: false,
        pageLoading: true,
        pagination: {
          onChange: (page) => {},
          pageSize: 5,
          size: "small",
        },
        initialEdit: {},
        modal: {
          modalEdit: false,
          confirmLoading: false,
          confirm: false,
          data: {
            tanggal_pemakaian: moment().format(),
            deskripsi: "",
            kredit: "",
            id: "",
            type: "",
            alokasi: "",
            proyek: "",
          },
        },
        kategori: "",
        peruntukan: [],
        subPeruntukan: [],
        anggaran: {
          peruntukan_id: "",
          anggaran_id: "",
          id_laporan: "",
          modalvalue: undefined,
          path: "",
          limit: 0,
          tree: [],
          treeModal: [],
          searchValue: "",
          loadingtree: false,
        },
        modalanggaran: {
          visible: false,
          enabled: false,
          loadingButton: false,
          value: undefined,
          tree: {},
          searchValue: "",
        },
        costCenter: [],
        treeExpandedKeys: [],
        EnCommission: true,
        Viwithout_note: true,
        doctransfiles: [],
        selectedCostCenter: null,
        listProspect: [],
        end_user_list: [],
        dataSPPDList: [],
        dataPPList: []
      };
    },
    computed: {
      ...mapGetters([
        "getAuth",
        "getScreen",
        "getDefaultDateFormat",
        "getStandartFormatDate",
        "getAlokasi",
        "getCostCenter",
        "getPeruntukan",
        "getSubPeruntukan",
        "getAnggaran",
        "getJenisAnggaran",
        "getSppdNoList",
        "getCCPPNoList",
        "getEndUserCC",
        "getCCEmpList",
        "getAllKaryawan",
      ]),
      initialList() {
        if (this.dataList.length > 0) {
          let kredit = 0;
          let data = this.dataList;
          if (this.dataList.length > 1 || this.dataList !== undefined) {
            data.forEach((item) => {
              kredit = parseInt(kredit) + parseInt(item.kredit);
            });
          }
  
          return { kredit: kredit };
        } else {
          return { kredit: 0 };
        }
      },
    },
    created() {
      this.$store.dispatch("FETCH_ALL_KARYAWAN");
      this.$store.dispatch("FETCH_ENDUSER_CC");
      this.$store.dispatch("FETCH_SPPD_NO_LIST");
      this.fetchPemakaian();
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
      this.formEdit = this.$form.createForm(this);
    },
    methods: {
      moment,
      recountingAnggaran(arr) {
        arr = arr.filter((obj) => obj.path !== "");
        if (arr.length > 0) {
          //restore nominal ke origin
          arr.forEach((elm) => {
            if(elm.path){
              let ObjVal = elm.path.split(";");
              let path1 = "";
              let path2 = "";
              let path3 = "";
              let trigerpath = true;
              let tempTree = this.anggaran.tree;
              ObjVal.forEach((element) => {
                if (path1 == "") {
                  path1 += "tempTree[" + element + "]";
                  path3 = path1;
                } else {
                  path3 = path1 + ".children";
                  path1 += ".children[" + element + "]";
                }
                if (trigerpath) {
                  if (!eval(path3)) {
                    trigerpath = false;
                    return;
                  } else {
                    if (!eval(path1)) {
                      trigerpath = false;
                      return;
                    }
                  }
                }
              });
  
              if (trigerpath) {
                path2 = eval(path1 + ".origin_rekap");
                eval(path1 + ".rekap=" + path2);
                //eval(path1+".disabled=false")
              }
            }
          });
          //menghitung nominal dengan acuan nominal origin
          arr.forEach((elem) => {
            if(elem.path){
              let ObjVal = elem.path.split(";");
              let path = "";
              let tpath = "";
              let trigerpath = true;
              let tempTree = this.anggaran.tree;
              ObjVal.forEach((element) => {
                if (path == "") {
                  path += "tempTree[" + element + "]";
                  tpath = path;
                } else {
                  tpath = path + ".children";
                  path += ".children[" + element + "]";
                }
                if (trigerpath) {
                  if (!eval(tpath)) {
                    trigerpath = false;
                    return;
                  } else {
                    if (!eval(path)) {
                      trigerpath = false;
                      return;
                    }
                  }
                }
              });
              if (trigerpath) {
                let kd_anggrn = eval(path + ".kode_anggaran");
                if (kd_anggrn == elem.kode_anggaran) {
                  let oldVal = eval(path + ".rekap");
                  let num = oldVal - parseFloat(elem.kredit);
                  let exe = path + ".rekap=" + num;
                  eval(exe);
                  if (num <= 0) {
                    eval(path + ".disabled=true");
                  } else {
                    eval(path + ".disabled=false");
                  }
                }
              }
              this.anggaran.tree = tempTree;
            }
          });
        }
      },
      async getTreeAnggaran() {
        this.anggaran.loadingtree = true;
        let dataParams =
          (this.mode == "Edit" && this.type == "revised") || (this.id_laporan && this.type == "draft")
            ? {
                anggaran_id: this.anggaran.anggaran_id,
                tlc: this.getAuth.username,
                peruntukan_id: this.anggaran.peruntukan_id,
                id_laporan: this.id_laporan,
              }
            : {
                anggaran_id: this.anggaran.anggaran_id,
                tlc: this.getAuth.username,
                peruntukan_id: this.anggaran.peruntukan_id,
              };
        if (dataParams.peruntukan_id) {
          await axios({
            method: "get",
            url: this.$serviceUrl + "klaim_cc/tree_anggaran",
            params: dataParams,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.anggaran.tree = response.data.tree;
              this.anggaran.treeModal = [
                ...this.anggaran.treeModal,
                response.data.tree[0],
              ];
  
              this.treeExpandedKeys = this.getParent(response.data.tree);
  
              if(this.selectedCostCenter=='07'){
                this.getProspectList();
              }else{
                this.anggaran.loadingtree = false;
              }
            })
            .catch((err) => {
              this.anggaran.loadingtree = false;
              console.log(err);
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            });
        }
        this.anggaran.loadingtree = false;
      },
      // filterTreeNode(input, option) {
      //   return (
      //     option.data.props.texttitle==undefined || (option.data.props.texttitle ? option.data.props.texttitle : "").toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
      //     (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "").toLowerCase().indexOf(input.toLowerCase()) >= 0
      //   );
      // },
      handleCodeAnggarn(e) {
        let forms = this.form.getFieldsValue();
        this.modalanggaran.value =
          forms.peruntukan + ";" + forms.sub_peruntukan + ";" + e;
      },
      filterTreeNode(input, option) {
        //console.log(input, option)
        return (
          option.data.props.texttitle == undefined ||
          (option.data.props.texttitle ? option.data.props.texttitle : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0 ||
          (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      handlechoiceCost(value, record) {
        this.anggaran.limit = record.dataRef.rekap;
        this.anggaran.path = record.dataRef.path;
  
        let isKomisi = this.getCommisionSts(this.anggaran.path);
        if(isKomisi){
          this.EnCommission = true;
          this.Viwithout_note = false;
          this.$nextTick(function () {
            this.form.setFieldsValue({
                iscommision: "1",
                without_note: "0",
            });
          });
        }else{
          this.EnCommission = false;
          this.Viwithout_note = true;
          this.$nextTick(function () {
            this.form.setFieldsValue({
                iscommision: "0",
                without_note: "0",
            });
          });
        }
        
        this.modalanggaran.visible = false;
  
      },
      getCommisionSts(val){
        let kdAnggrn = val.split(";");
        let text = "";
        for (let i = 0; i < (kdAnggrn.length-1); i++) {
          if (i==0){
            text="this.anggaran.tree[0]";
          }else{
            text = text+".children["+kdAnggrn[i]+"]";
          }
        }
        text = eval(text+".title");
        let sts = false;
        if(text.toLowerCase().includes("komisi"))
          sts = true;
        return sts;
      },
      showChoiceModal() {
        this.modalanggaran.visible = true;
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },

      beforeUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        let extension =
          file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
          file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
        if (extension) {
          if (FileSize > 2) {
            this.displayMessage("large-file-2mb");
          } else {
            this.push = [file];
            this.form.resetFields();
            return false;
          }
        } else {
          this.displayMessage("error-formatXls");
        }
      },
      done() {
        this.pageLoading = false;
      },
      fetchPemakaian() {
        this.pageLoading = true;
        Event.$emit("fetchPemakaian", true);
      },
      fetchPemakaianUploadFile(params) {
        Event.$emit("fetchPemakaianAfterUpload", params);
      },
      handleRemoveDetail(e) {
        if (this.mode == "Edit" && this.dataList.length == 2) {
          this.displayMessageValue(
            "error-other",
            "can not delete this data, because this transaction has at least 1 data!"
          );
        } else {
          Event.$emit("removeDetail", e);
        }
      },
      handleNew() {
        if (this.push.length>0) {
          this.handleNewProcess();
        }else{
          this.form.validateFields((err, values) => {
            if (err) {
              this.newLoading = false;
              this.pageLoading = false;
              this.displayMessage("form-warning");
              return;
            }
  
            if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
              this.newLoading = false;
              this.pageLoading = false;
              this.displayMessageValue("error-other", "Expense date can't exceed today!");
              return;
            }
            //antisipasi error bigint postgresql
            // if (this.dataList && this.dataList.length>0 && this.debit>0){
            //   let nom = this.kredit+parseFloat(values.pengeluaran_kas_kecil)
            //   if (this.debit<nom){
            //     this.displayMessageValue("error-other","The value max Petty Cash is "+this.formatRupiah(this.debit))
            //     return
            //   }else{
            //     this.confirmMessageValue("confirm-add-detil", true);
            //   }
            // }else{
            // this.confirmMessageValue("confirm-add-detil", true);
            //}
            this.handleNewProcess();
          });
        }
      },
      handleNewProcess() {
        this.newLoading = true;
        let addData = new FormData();
        Event.$emit("handleLoading", true);
  
        if (this.push.length > 0 && this.dataList.length > 0) {
          this.confirm = true;
        }else if (this.push.length > 0) {
          this.push.forEach((file) => {
            addData.append("file_upload", file);
          });
          addData.append("id_user_cc", this.informasi.id_user_cc);
          addData.append("report_date", this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate));
  
          this.newLoading = true;
          this.pageLoading = true;
  
          this.postUpload(addData);
        } else {
          this.form.validateFields((err, values) => {
            if (err) {
              this.newLoading = false;
              this.pageLoading = false;
              Event.$emit("handleLoading", false);
              this.displayMessage("form-warning");
              return;
            }

            addData.append("report_date", this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate));
            addData.append("description", values.deskripsi ? values.deskripsi : "");
            if(values.sppd_no)
            addData.append("sppd_no", values.sppd_no);
            if(values.pp_no)
            addData.append("pp_no", values.pp_no);
            if(values.cost_center)
              addData.append("cost_center", values.cost_center);
            if(values.end_user){
              addData.append("end_user", values.end_user);
              addData.append("end_user_name", this.getCCEmpList.filter(item=>item.tlc==values.end_user)[0].nama);
            }
            if(values.end_user_name)
            addData.append("end_user_name", values.end_user_name);
            addData.append("credit", values.kredit);
            addData.append("id_laporan", this.id_laporan);
            addData.append("expense_date", values.tanggal_pengeluaran.format(this.getStandartFormatDate));
            addData.append("id_user_cc", this.informasi.id_user_cc);
            addData.append("no_booking", values.no_booking);
            addData.append("user_booking", values.user_booking);
            addData.append("tipe_tiket", values.tipe_tiket);
  
            if (this.doctransfiles && this.doctransfiles.length > 0) {
              this.doctransfiles.forEach((file) => {
                addData.append("file_upload", file);
              });
            }
            this.newLoading = true;

            axios({
              method: "post",
              url: this.url,
              processData: false,
              data: addData,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "multipart/form-data",
                "X-API-KEY": this.getAuth.apikey,
              },
            }).then((response) => {
              this.displayMessage("success-add");
              
              Event.$emit("id_laporan", response.data.id_laporan);
              localStorage.setItem('_temp_id', response.data.id_laporan)
              this.fetchPemakaian();

              this.newLoading = false;
              this.pageLoading = false;
              this.form.resetFields();

              if (this.mode === "Create") {
                  Event.$emit("disableInformasi", true);
              }
              
              this.modalanggaran.value = null;
              this.doctransfiles = [];
            }).catch((err) => {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
                console.log("error : " + err);
                Event.$emit("handleLoading", false);
            });
          });
        }
      },
      postUpload(data) {
        let url =
          this.type === "revised"
            ? "lap_tiket_pd/revisi_upload_detil_pemakaian"
            : "lap_tiket_pd/upload_detil_pemakaian";
        axios({
          method: "post",
          url: this.$serviceUrl + url,
          processData: false,
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            if (response.data.id_laporan){
              if (this.mode === "Create") {
                this.push = [];
                this.displayMessage("success-add");
                // this.fetchPemakaianUploadFile(response.data);
                // this.newLoading = false;
                // this.pageLoading = false;
                // this.confirm = false;
                // Event.$emit("disableInformasi", true);
                this.$router.push({ name: "edit_klaim_tiket", params: { id: response.data.id_laporan, type: 'draft' } }).then(()=>{
                  this.$router.go(0)
                })
              } else {
                this.push = [];
                this.displayMessage("success-edit");
                this.fetchPemakaianUploadFile(response.data);
                this.newLoading = false;
                this.pageLoading = false;
                this.confirm = false;
                Event.$emit("disableInformasi", true);
              }
            }else{
              this.displayMessageValue(
                "error-other",
                response.data.message
              );
              this.newLoading = false;
              this.pageLoading = false;
              this.confirm = false;
              Event.$emit("disableInformasi", true);
            }
            this.push = [];
            this.confirmLoading = false;
            Event.$emit("handleLoading", false);
          })
          .catch((err) => {
            console.log(err);
            this.confirmLoading = false;
            Event.$emit("handleLoading", false);
          });
      },
      handleCheckData(e) {
        Event.$emit("draftStatus", e.target.checked);
      },
      handleEdit(item) {
        this.modal.data = {
          path: item.path,
          tanggal_pemakaian: item.tanggal_pemakaian,
          deskripsi: item.deskripsi,
          kredit: item.kredit,
          id: item.id,
          type: this.type,
          proyek: item.proyek,
          alokasi: item.alokasi,
          jns_anggaran_id: item.jns_anggaran_id,
          anggaran_code: item.kode_anggaran_id=="null;null;null"? undefined : item.kode_anggaran_id,
        };
        this.modal.modalEdit = true;
        this.modal.type = this.type;
      },
      handleDownload() {
        axios({
          method: "get",
          url: this.$serviceUrl + "/main/download_template_klaim_cc",
          params: {
            id_lk: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            window.open(this.$serviceUrl + response.data.url, "_blank");
          })
          .catch((err) => {
            this.displayMessage("error-emptyDocTemplate");
          });
      },
      handleCancel(e) {
        this.confirm = false;
        this.modal.modalEdit = false;
      },
      checkPrice(rule, value, callback) {
        if (value > 0) {
          callback();
          return;
        }
        callback("Price must greater than zero!");
      },
      handleProyek(value) {
        let filter = this.project.filter(
          (obj) =>
            obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
        );
  
        this.kategori = filter[0].kategori;
        this.form.setFieldsValue({
          alokasi: "",
        });
      },

      resetFormPemakaian(spesificScopes) {
        this.form.resetFields();
        this.costCenter = [];
        this.peruntukan = [];
        if(spesificScopes)
          this.anggaran.tree = [];
        this.getTreeAnggaran();
      },
      getParent(root) {
        let data = [];
        root.forEach((item) => {
          if (item.key) {
            data.push(item.key);
          }
  
          if (item.children.length > 0) {
            item.children.forEach((d) => {
              data.push(d.key);
            });
          }
        });
        return data;
      },
      handleconfirmOk() {
        Event.$emit("handleLoading", true);
        this.ModalText = "The modal will be closed after two seconds";
        this.confirmLoading = true;
  
        let addData = new FormData();
  
        addData.append("tlc", this.getAuth.username);
        addData.append("id_laporan", this.id_laporan);
        addData.append(
          "tanggal_pelaporan",
          moment(this.informasi.tanggal_pelaporan).format(this.getStandartFormatDate)
        );
        addData.append("approval_pic", this.informasi.pic);
        addData.append("approval_bod", this.informasi.bod);
        addData.append("id_user_cc", this.informasi.id_user_cc);
        this.push.forEach((file) => {
            addData.append("file_upload", file);
          });
  
        this.postUpload(addData);
      },
      handleconfirmCancel() {
        this.confirm = false;
        //this.modal.modalEdit = false;
      },
      handleRemove(){
        this.push = [];
      },
      filterOptionTlc(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      handleOptionCommission(val){
        if(val.target.value=="1"){
          this.Viwithout_note = false;
        }else{
          this.Viwithout_note = true;
        }
        this.$nextTick(function () {
            this.form.setFieldsValue({
                without_note: "0",
            });
          });
      },
      beforedoctransUpload(file) {
        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 5) {
          this.displayMessage("large-file-5mb");
        } else {
          this.doctransfiles = [file];
          return false;
        }
      },
      handledoctransRemove() {
        this.doctransfiles = [];
      },
      async getProspectList(){
        await axios({
          method: "get",
          url: this.$serviceUrl + "prospek/pilih_prospek",
          params: {
            anggaran_id: this.anggaran.anggaran_id
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then(async (response) => {
          this.listProspect = response.data.data ? response.data.data : [];
          this.anggaran.loadingtree = false;
        })
        .catch(() => {
        });
      },
      handleSearchSPPD(value) {
        const list = this.getSppdNoList
        fetchLazySPPD(list, value, data => (this.dataSPPDList = data));
      },
      onChangeSppdNo(e) {
        const list = this.getSppdNoList
        fetchLazySPPD(e, data => (list, this.dataSPPDList = data))
      },
      handleSearchPP(value) {
        const list = this.getCCPPNoList
        fetchLazyPP(list, value, data => (this.dataPPList = data));
      },
      onChangePPNo(e) {
        const list = this.getCCPPNoList
        fetchLazyPP(list, e, data => (list, this.dataPPList = data))
      },
      handleSearchCostCenter(value) {
        const list = this.getCostCenter
        fetchLazyCostCenter(list, value, data => (this.dataPPList = data));
      },
      onChangeCostCenter(e) {
        const list = this.getCostCenter
        fetchLazyCostCenter(list, e, data => (list, this.dataPPList = data))
      },
      handleDownloadTemplate() {
        axios({
          method: "get",
          url:
            this.$serviceUrl +
            "/main/download_template_klaim_tiket",
          params: {
            id_lk: this.id,
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            window.open(this.$serviceUrl + response.data.url, "_blank");
          })
          .catch((err) => {
            this.displayMessage("error-emptyDocTemplate");
          });
      },
      beforeUploadTemplate(file) {
        const FileSize = file.size / 1024 / 1024;
        let extension =
          file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
          file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
        if (extension) {
          if (FileSize > 2) {
            this.displayMessage("large-file-2mb");
          } else {
            this.push = [file];
            this.form.resetFields();
            return false;
          }
        } else {
          this.displayMessage("error-formatXls");
        }
      },
      handleRemoveTemplate(){
      this.push = [];
    },
    },
    mounted() {
      this.$store.dispatch("FETCH_COST_CENTER");
      Event.$on("modalCancel", this.handleCancel);
      Event.$on("confirmMessageAddDetil", this.handleNewProcess);
      Event.$on("resetdtlpemakaian", this.resetFormPemakaian);
    },
    beforeDestroy() {
      Event.$off("modalCancel", this.handleCancel);
      Event.$off("confirmMessageAddDetil", this.handleNewProcess);
      Event.$off("resetdtlpemakaian", this.resetFormPemakaian);
    },
    watch: {
    }
  };
  </script>
  
  <style lang="less">
  .ant-select-selection-selected-value {
    width: 100%;
  }
  
  .ant-input-number-input{
      text-align: right;
      padding-right: 25px;
    }
  </style>